import React, { useEffect, useState } from 'react';
import { getTargetConfig } from '../helper/InitTargetHelper';
import InitView from './InitView';
import DevLauncherButton from './dev/DevLauncherButton';

// 개발자 진입 라우터.
// 1. ?target=<key>  → InitTargetHelper 의 TARGET_CONFIG_MAP 으로 회사 자동 진입
// 2. (no target)    → 기존 InitView (회사 선택 form) + 우측 상단 DevLauncher 버튼
function EntryRouter() {
  const [targetConfig, setTargetConfig] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const searchStr = window.location.hash.split('?')[1] || '';
    const params = new URLSearchParams(searchStr);
    const target = params.get('target');
    const mode = params.get('mode'); // 'chat' | 'voice' | null (기본 voice)
    const config = getTargetConfig(target);
    if (config) {
      setTargetConfig({ ...config, mode: mode === 'chat' ? 'chat' : 'voice' });
    }
    setReady(true);
  }, []);

  if (!ready) return null;

  if (targetConfig) {
    return <InitView targetConfig={targetConfig} />;
  }

  return (
    <>
      <InitView />
      <DevLauncherButton />
    </>
  );
}

export default EntryRouter;
